import { gql } from "@apollo/client";
import { APICall } from "../api_helper";

export const CREATE_ORGANIZATION = gql`
  mutation createOrganization(
    $session: String!
    $name: String!
    $parentOrganizationId: Int
    $childOrganizationIds: [Int]
    $eventMetadata: EventMetadata!
  ) {
    createOrganization(
      session: $session
      name: $name
      parentOrganizationId: $parentOrganizationId
      childOrganizationIds: $childOrganizationIds
      eventMetadata: $eventMetadata
    ) {
      name
      id
      parentOrganization {
        id
        name
      }
      childOrganizations {
        id
        name
      }
    }
  }
`;

export const UPDATE_ORGANIZATION = gql`
  mutation updateOrganization(
    $session: String!
    $id: Int!
    $name: String!
    $parentOrganizationId: Int
    $childOrganizationIds: [Int]
    $eventMetadata: EventMetadata!
  ) {
    updateOrganization(
      session: $session
      id: $id
      name: $name
      parentOrganizationId: $parentOrganizationId
      childOrganizationIds: $childOrganizationIds
      eventMetadata: $eventMetadata
    ) {
      id
      name
      parentOrganization {
        id
        name
      }
      childOrganizations {
        id
        name
      }
    }
  }
`;

export const DELETE_ORGANIZATION_API_CALL: APICall = {
  documentNode: gql`
    mutation deleteOrganization(
      $session: String!
      $id: Int!
      $eventMetadata: EventMetadata!
      $isChildElement: Boolean!
      $parentDeletionStrategy: ParentDeletionStrategy
    ) {
      deleteOrganization(
        session: $session
        id: $id
        eventMetadata: $eventMetadata
        isChildElement: $isChildElement
        parentDeletionStrategy: $parentDeletionStrategy
      )
    }
  `,
  key: "deleteOrganization",
};

export const DELETE_ORGANIZATION = gql`
  mutation deleteOrganization(
    $session: String!
    $id: Int!
    $eventMetadata: EventMetadata!
  ) {
    deleteOrganization(
      session: $session
      id: $id
      eventMetadata: $eventMetadata
    ) {
      id
    }
  }
`;

export const CREATE_PERSON = gql`
  mutation createPerson(
    $session: String!
    $name: String!
    $organizationIds: [Int]
    $eventMetadata: EventMetadata!
  ) {
    createPerson(
      session: $session
      name: $name
      organizationIds: $organizationIds
      eventMetadata: $eventMetadata
    ) {
      id
      name
      organizations {
        id
        name
      }
    }
  }
`;

export const UPDATE_PERSON = gql`
  mutation updatePerson(
    $session: String!
    $id: Int!
    $name: String!
    $organizationIds: [Int]
    $eventMetadata: EventMetadata!
  ) {
    updatePerson(
      session: $session
      id: $id
      name: $name
      organizationIds: $organizationIds
      eventMetadata: $eventMetadata
    ) {
      id
      name
      organizations {
        id
        name
      }
    }
  }
`;

export const DELETE_PERSON = gql`
  mutation deletePerson(
    $session: String!
    $id: Int!
    $eventMetadata: EventMetadata!
  ) {
    deletePerson(session: $session, id: $id, eventMetadata: $eventMetadata)
  }
`;

export const LIST_PEOPLE = gql`
  query listPeople($session: String!) {
    listPeople(session: $session) {
      id
      name
      organizations {
        id
        name
      }
    }
  }
`;

export const LIST_ORGANIZATIONS = gql`
  query listOrganizations($session: String!) {
    listOrganizations(session: $session) {
      id
      name
      hasChildren
      parentOrganization {
        id
        name
      }
      childOrganizations {
        id
        name
      }
    }
  }
`;
